import { SVGProps } from 'react';
import cn from 'classnames';
import Button from '@raydiant/raydial/components/Button';

interface ContentCardActionButtonProps {
  className?: string;
  icon: SVGProps<SVGSVGElement>;
  label: string;
  onClick: () => void;
  isDisabled?: boolean;
}

const ContentCardActionButton = ({
  className,
  icon,
  label,
  onClick,
  isDisabled = false,
}: ContentCardActionButtonProps) => {
  return (
    <Button
      className={cn(
        'w-full flex items-center gap-2 py-2.5 px-4 cursor-pointer hover:bg-gray-200 min-h-[40px]',
        className,
      )}
      variant="unstyled"
      onPress={(e) => {
        (e as any).stopPropagation?.();
        onClick();
      }}
      isDisabled={isDisabled}
    >
      <div className="flex shrink-0 items-center justify-center w-[17px] h-[17px] [&_svg]:block [&_svg]:shrink-0 [&_svg]:max-w-[17px] [&_svg]:max-h-[17px] [&_span]:inline-flex [&_span]:items-center [&_span]:justify-center">
        {icon}
      </div>
      <span className="flex items-center pt-0.5 text-base leading-tight">
        {label}
      </span>
    </Button>
  );
};

export default ContentCardActionButton;
